module.exports = __webpack_public_path__ + "img/yellow_2048.33e03d8c.png";